import React from 'react';

/**
 * KPI value block — small label on top, large mono numeral, optional
 * mono delta in tone color, optional sub-text below.
 *
 *   label      uppercase-feel small label ("Total billed")
 *   value      the displayed value, already formatted ("$5.38M")
 *   delta      optional secondary numeral ("+$2.16M YTD", "46.0%")
 *   deltaTone  'pos' | 'neg' | 'neut' — picks delta color
 *   sub        optional muted line below ("across 7 projects")
 *   size       'sm' | 'md' | 'lg' — controls value font size
 *   mono       set false for non-numeric labels rendered as values
 */
const DELTA_TONE = {
  pos: 'var(--success)',
  neg: 'var(--danger)',
  neut: 'var(--text-3)',
};

export default function Stat({
  label,
  value,
  delta,
  deltaTone = 'neut',
  sub,
  size = 'md',
  mono = true,
}) {
  const fs = size === 'lg' ? 28 : size === 'sm' ? 18 : 22;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <div
        style={{
          fontSize: 12.5,
          color: 'var(--text-3)',
          fontWeight: 500,
          letterSpacing: '0.02em',
        }}
      >
        {label}
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <div
          className={mono ? 'mono' : undefined}
          style={{
            fontSize: fs,
            fontWeight: 500,
            color: 'var(--text-1)',
            letterSpacing: '-0.025em',
            lineHeight: 1.1,
          }}
        >
          {value}
        </div>
        {delta && (
          <div
            className="mono"
            style={{
              fontSize: 12.5,
              color: DELTA_TONE[deltaTone] || DELTA_TONE.neut,
              fontWeight: 500,
            }}
          >
            {delta}
          </div>
        )}
      </div>
      {sub && (
        <div style={{ fontSize: 12.5, color: 'var(--text-3)' }}>{sub}</div>
      )}
    </div>
  );
}
